<app-loading *ngIf="isLoading"></app-loading>
<div class="detail-container requirementContent">
  <label>{{ "claimOffice.requirements.title" | translate }}</label>
  <dxc-table class="table-responsive-sm dashabordTable pt-4 pb-4">
    <tr class="header-filter">
      <th id="colsrNo">
        <div class="d-flex">
          {{ "claimOffice.requirements.srNo" | translate }}
        </div>
      </th>

      <th id="colTitle">
        <div class="d-flex">
          {{ "claimOffice.requirements.title" | translate }}
        </div>
      </th>
      <th id="colDescRequirements">
        <div class="d-flex">
          {{ "claimOffice.requirements.descRequirements" | translate }}
        </div>
      </th>
      <th id="colStatus">
        <div class="d-flex">
          {{ "claimOffice.requirements.status" | translate }}
        </div>
      </th>
      <th id="colReports">
        <div class="d-flex">
          {{ "claimOffice.requirements.reports" | translate }}
        </div>
      </th>
    </tr>
    <tr
      class="table-header"
      *ngFor="let item of requirementDetails; let i = index"
    >
      <td>
        <span class="mobile-label"
          >{{ "claimOffice.requirements.srNo" | translate }}
        </span>
        <span>{{ i + 1 }} </span>
      </td>
      <td>
        <span class="mobile-label"
          >{{ "claimOffice.requirements.title" | translate }}
        </span>
        <span>{{ item.requirementKey }} </span>
      </td>
      <td>
        <span class="mobile-label"
          >{{ "claimOffice.requirements.descRequirements" | translate }}
        </span>
        <span>{{ item.requirementDesc }}</span>
      </td>
      <td>
        <span class="mobile-label"
          >{{ "claimOffice.requirements.status" | translate }}
        </span>
        <span>{{ item.statusDesc }} </span>
      </td>

      <td class="imgCell text-center">
        <span class="mobile-label"
          >{{ "claimOffice.requirements.reports" | translate }}
        </span>
        <div>
          <custom-button
            class="mr-4"
            margin="xxsmall"
            mode="text"
            [iconSrc]="generatePaymentIcon"
          >
          </custom-button>
        </div>
      </td>
    </tr>
  </dxc-table>
</div>
